import {
    FormControl,
    FormHelperText,
    TextField,
    Autocomplete, createFilterOptions
} from "@mui/material";

export default function SingleSelect({
    name,
    label,
    options,
    value,
    onChange,
    error,
    disabled,
    formHelperText,
}) {

    const filterOptions = createFilterOptions({
        limit: 50, // show only first 50 results for performance
        matchFrom: "start", // or "any"
        stringify: (option) => option.label,
    });
    const selectedOption =
        options.find((opt) => opt.value === value) || null;

    return (
        <FormControl fullWidth size="small" error={Boolean(error)}>
            <Autocomplete
                freeSolo
                options={options}
                filterOptions={filterOptions}
                value={selectedOption || ""}
                // value={options.find(o => o.label === field.value) || null}
                onChange={(_, newValue) => onChange(name, newValue?.value || "")}
                getOptionLabel={(option) => option.label || ""}
                disableClearable
                disabled={disabled}
                MenuProps={{ autoFocus: false, }}
                size="small"
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        error={Boolean(error)}
                    />
                )}
                renderOption={(props, option) => (
                    <li {...props}>
                        <div style={{ whiteSpace: "pre-line" }}>
                            {option.label}
                        </div>
                    </li>
                )}
            />
            {formHelperText && error && (
                <FormHelperText>{error}</FormHelperText>
            )}
        </FormControl>
    );
}
